import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar'
import Modal from 'react-modal';
import walletimg from '../../../images/wallet-1.jpg'
import { Helmet } from 'react-helmet';
import BACKEND_URL from '../../../api'
import { useCountry } from '../../../context/CountryContext'
import '../../../My_Account.css'

export default function My_wallet() {
    const { currency } = useCountry();

    const navigate = useNavigate()
    const [amount, setamount] = useState()
    const [wallet, setwallet] = useState()
    const [current, setcurrent] = useState(10)
    const [page, setpage] = useState(0)
    const userid = sessionStorage.getItem('userid')
    function payamount() {
        axios({
            method: 'post',
            url: `${BACKEND_URL}/generateWalletPayment`,
            data: { userid: userid, amount: amount }
        })
            .then((res) => {
                console.log("generateWalletPayment----------:", res.data)
                navigate('/checkout', { state: { orderno: 1, payment_page: res.data._links.payment.href } })
            })
            .catch(err => console.log(err))
    }
    const [showbooking, setshowbooking] = useState(true)
    const [showtrans, setshowtrans] = useState(false)
    const [transactions, settransactions] = useState()
    const [counttransactions, setcounttransactions] = useState()
    const [booking, setbooking] = useState()
    const [countbooking, setcountbooking] = useState()
    const [parcelcount2, setparcelcount2] = useState(0)
    const [isOpen, setIsOpen] = useState(false);
    const [selectedCss, setSelectedCss] = useState(false);
    const [checkboxList, setCheckboxList] = useState([false, false, false]);
    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        axios({
            method: "post",
            url: `${BACKEND_URL}/getWallet`,
            data: { userid: userid, current: "" }
        })
            .then((res) => {
                console.log("getWallet---------:", res.data)
                setwallet(res.data.wallet)
                settransactions(res.data.transactions)
                setcounttransactions(res.data.transactions.length)
                setbooking(res.data.bookings)
                setcountbooking(res.data.bookings.length)
                setparcelcount2(res.data.totparcel.length)
            })
            .catch((err) => console.log(err))
    }, [])

    const updateCheckbox = (i) => {
        const updatedCheckboxList = checkboxList.map((item, index) => {
            return index === i ? true : false;
        });

        setCheckboxList(updatedCheckboxList);
    }

    function bonus_payment(amt) {
        axios({
            method: 'post',
            url: `${BACKEND_URL}/generateWalletPayment`,
            data: { userid: userid, amount: amt }
        })
            .then((res) => {
                console.log("generateWalletPayment----------:", res.data)
                navigate('/checkout', { state: { orderno: 1, payment_page: res.data._links.payment.href } })
            })
            .catch(err => console.log(err))
    }

    function showfun(val) {
        if (val == 'booking') {
            setshowbooking(true)
            setshowtrans(false)
        } else {
            setshowbooking(false)
            setshowtrans(true)
        }

    }
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const setModalIsOpenToTrue = () => {
        setModalIsOpen(true)
    }

    const setModalIsOpenToFalse = () => {
        setModalIsOpen(false)
    }

    function nextpage(val1) {
        axios({
            method: "post",
            url: `${BACKEND_URL}/getWallet`,
            data: { userid: userid, current: val1 }
        })
            .then((res) => {

                if (res.data.parcel != "") {
                    if (val1 > page) {
                        setcurrent(current + 10)
                    }
                    if (val1 < page) {
                        setcurrent(current - 10)
                    }
                    setpage(val1)
                    setbooking(res.data.bookings)
                    setcountbooking(res.data.bookings.length)
                }
            })
            .catch((err) => console.log(err))
    }

    return (

        <div className="my_parcels">
            <Helmet>
                <title>Shypv | My Wallet</title>
            </Helmet>
            <Modal isOpen={modalIsOpen} ariaHideApp={false}>
                <div style={{ position: 'sticky', top: 0, zIndex: 1000 }}>

                    <button onClick={setModalIsOpenToFalse} style={{ float: "right" }}>x</button>
                    <h5 classname="modal-title title-mod" id="exampleModalLongTitle" style={{ color: '#3c50e1', backgroundColor: "white", textTransform: "uppercase", fontWeight: "bold", marginBottom: "5%" }}>To add money to you wallet</h5>

                </div>
                <>

                    <div className="container">
                        <div className="modal-body title-mod-body">
                            <div className="col-md-12"><img src={walletimg} height="auto" style={{ width: "100%" }} />
                            </div>
                            <div className="col-md-12">
                                <h4 style={{ marginBottom: 0 }}>Ship cheaper and earn more with Pay By Wallet</h4>
                                <p>1. Select exact amount you want to add to your wallet.</p>
                                <p>2. Choose one of Bulk Buy Bonus schemes and save more!</p>
                                <p>Note: Use your Pay By Wallet credits to send your parcels at checkout page.</p>
                                {/* <p>Note: After payment success your wallet money will add automatically to "My Balance".</p> */}
                            </div>
                        </div>
                    </div>

                </>
            </Modal>
            <div className="myparctab" style={{ padding: "0" }}>

                <div className="container-fluid" style={{ padding: "0" }}>
                    <div className="row1">

                        <Sidebar isOpen={isOpen} />

                        {/* /#admin-sidebar */}
                        <div id="admin-main-control" className="col-md-9 p-x-3 p-y-1" style={{ overflow: "auto", backgroundColor: "#f1f5f9" }}>
                            <div style={{ boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)" }}>
                                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                                    <div className="container-fluid" style={{ justifyContent: "space-between" }}>
                                        <button className="navbar-toggler" type="button" onClick={toggleSidebar}>
                                            {
                                                isOpen ? (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="32"
                                                        height="32"
                                                        className="bi bi-arrow-bar-left"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5"
                                                        />
                                                    </svg>
                                                ) : (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="32"
                                                        height="32"
                                                        className="bi bi-arrow-bar-right"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8m-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5"
                                                        />
                                                    </svg>
                                                )
                                            }
                                        </button>
                                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"></span>
                                        </button>
                                        <div className="offset-1 collapse navbar-collapse" id="navbarNav">
                                            <ul className="navbar-nav">
                                                <>
                                                    <li className="nav-item">
                                                        <NavLink activeclassname="active" exact to="/">HOME</NavLink>
                                                        {/* <Link className="nav-link active"  aria-current="page" exact  to="/">HOME  </Link> */}
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink exact to="/track">TRACK</NavLink>
                                                        {/* <Link className="nav-link" exact  to="/track">TRACK</Link> */}
                                                    </li>

                                                    {/* <li className="nav-item">
                                                            <NavLink exact to="/smart-send">SMART SEND</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/your-business">YOUR BUSINESS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/help">HELP</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/become-a-partner">PARTNERS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/parcels-on-demand">HOW IT WORKS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a href="https://www.tymexlogistics.com/" target="_blank">LOGISTICS</a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/client-zone">CLIENT ZONE</NavLink>
                                                        </li> */}
                                                </>
                                            </ul>
                                        </div>
                                    </div>
                                </nav>
                            </div>

                            <div style={{ margin: "20px", padding: "20px", backgroundColor: "white", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)" }}>
                                <div className="col-md-12 col-sm-12 col-xs-12" style={{ border: "1px solid #c3bbbb" }}>
                                    <div className="head" style={{ background: "#f5f5f5", padding: "1%" }}>
                                        <h3 className="comaprison_hedding">My Wallet </h3>
                                        <a onClick={setModalIsOpenToTrue} style={{ color: "#3c50e1", cursor: "pointer" }}>How to use</a>
                                    </div>
                                    <div className="row" style={{ textAlign: "center", padding: "15px", margin: "15px" }}>
                                        <div className="col-md-4" >
                                            <h5>MY WALLET</h5>
                                            <div className="row" style={{ textAlign: "center", border: "1px solid #3c50e1" }}>
                                                <div className="col-md-12" style={{ background: "#3c50e1", color: "#fff" }}>
                                                    <h6 style={{ padding: "1%" }}>My Balance</h6>
                                                </div>
                                                <div className="col-md-12" style={{ padding: "8%" }}>
                                                    {Number(wallet).toFixed(2)} {currency}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-7 offset-1 walletmoney">
                                            <h5>ADD MONEY TO YOUR WALLET</h5>
                                            <div className="row" style={{ textAlign: "center", border: "1px solid #3c50e1", background: "#f5f5f5" }}>
                                                <div className="col-md-12" >
                                                    <div className="row">
                                                        <div className="col-md-4" style={{ background: "#3c50e1", color: "#fff" }}> <h6 style={{ padding: "1%" }}>Value:</h6></div>
                                                        <div className="col-md-8" style={{ background: "#f5f5f5", color: "#fff", padding: "0" }}> <input type="number" min={0} onChange={(e) => setamount(e.target.value)} style={{ background: "#f5f5f5", border: "none", border: "none", borderBottom: "1px solid", padding: "1%", width: "100%" }} /></div>
                                                    </div>

                                                </div>
                                                <div className="col-md-12" style={{ padding: "8%" }}>
                                                    <button type="submit" onClick={payamount} style={{ color: '#fff', textAlign: '', backgroundColor: '#3c50e1bf', width: '35%', padding: "2%", border: "1px solid" }}>Pay Now</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-12 col-sm-12 col-xs-12" style={{ border: "1px solid #c3bbbb", marginTop: "2%", borderRadius: "6px" }}>

                                    <div className="table-responsive " style={{ padding: '25px', overflow: "auto" }}>
                                        <h4 className="panel-title" style={{ fontSize: '20px', marginBottom: "1px" }}>Bulk Buy Bonus</h4>
                                        <div style={{ marginBottom: "15px" }}>
                                            <p style={{ fontSize: "14px" }}>Earn FREE BONUS CREDIT when you buy our below packages to top up your wallet.</p>
                                        </div>
                                        <a className="booking" onClick={() => {
                                            if (checkboxList[0] === true) {
                                                bonus_payment(500)
                                            } else if (checkboxList[1] === true) {
                                                bonus_payment(700)
                                            } else if (checkboxList[2] === true) {
                                                bonus_payment(1000)
                                            }
                                        }}>Pay Now</a>

                                        <table className="table-custom" style={{ marginTop: "2%" }}>
                                            <thead className="table-header-row">
                                                <tr>
                                                    <th></th>
                                                    <th>Add to Wallet</th>
                                                    <th>Free Extra Money!</th>
                                                    <th>Total in Wallet</th>
                                                </tr>
                                            </thead>
                                            <tbody className="table-body">
                                                <tr className="table-row even">
                                                    <td className='table-cell'>
                                                        <input type="checkbox" name="Sectors" checked={checkboxList[0]} onChange={(e) => updateCheckbox(0)} style={{ width: "15px", height: "15px", display: 'flex', justifySelf: "center" }} />
                                                    </td>
                                                    <td className="table-cell">Add 500 {currency} - Get 25 Free</td>
                                                    <td className="table-cell">+25 {currency}</td>
                                                    <td className="table-cell">525 {currency}</td>
                                                </tr>
                                                <tr className="table-row odd">
                                                    <td className='table-cell'>
                                                        <input type="checkbox" name="Sectors" checked={checkboxList[1]} onChange={(e) => updateCheckbox(1)} style={{ width: "15px", height: "15px", display: 'flex', justifySelf: "center" }} />
                                                    </td>
                                                    <td className="table-cell">Add 700 {currency} - Get 50 Free</td>
                                                    <td className="table-cell">+50 {currency}</td>
                                                    <td className="table-cell">750 {currency}</td>
                                                </tr>
                                                <tr className="table-row even">
                                                    <td className='table-cell'>
                                                        <input type="checkbox" name="Sectors" checked={checkboxList[2]} onChange={(e) => updateCheckbox(2)} style={{ width: "15px", height: "15px", display: 'flex', justifySelf: "center" }} />
                                                    </td>
                                                    <td className="table-cell">Add 1000 {currency} - Get 100 Free</td>
                                                    <td className="table-cell">+100 {currency}</td>
                                                    <td className="table-cell">1100 {currency}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* transaction history */}

                                <div className="col-md-12 col-sm-12 col-xs-12" style={{ border: "1px solid #c3bbbb", marginTop: "2%", borderRadius: "6px" }}>

                                    <div className="table-responsive " style={{ padding: '25px' }}>
                                        <h3 className="panel-title comaprison_hedding">Your Money History</h3>
                                        <div className="wallettrans">
                                            <a
                                                className={selectedCss === false ? "booking" : "onlinewallet"}
                                                onClick={() => {
                                                    showfun('booking');
                                                    setSelectedCss(false);
                                                }}
                                            >
                                                BOOKINGS
                                            </a>
                                            <a
                                                className={selectedCss === true ? "booking" : "onlinewallet"}
                                                onClick={() => {
                                                    showfun('online');
                                                    setSelectedCss(true);
                                                }}
                                            >
                                                ONLINE PAYMENT
                                            </a>
                                        </div>
                                        {showbooking ? (
                                            <>
                                                <table className="table-custom">
                                                    <thead className="table-header-row">
                                                        <tr>
                                                            <th>DATE</th>
                                                            <th>ORDER ID</th>
                                                            <th>AMOUNT</th>
                                                            <th>STATUS</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="table-body">
                                                        {
                                                            [...Array(countbooking)].map((e, i) => <>
                                                                {booking && booking[i] != '' ? (
                                                                    <tr key={i} className={`table-row ${i % 2 === 1 ? 'odd' : 'even'}`}>
                                                                        <td className="table-cell">{booking[i].updated_on}</td>
                                                                        <td className="table-cell">{booking[i].id}</td>
                                                                        <td className="table-cell">{booking[i].total_price} PAID</td>
                                                                        <td className="table-cell">BOOKING</td>
                                                                    </tr>
                                                                ) : null}
                                                            </>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>

                                                <div className="pagination-sec fw">
                                                    <div>
                                                        <p class="pagination-info">
                                                            Showing{" "}
                                                            <span class="font-medium">{page * 10 + 1}</span> {" "}to{" "}
                                                            {(page * 10 + 10) > parcelcount2 ? (
                                                                <span class="font-medium">{" "}{parcelcount2}{" "}</span>
                                                            ) : (
                                                                <span class="font-medium">
                                                                    {" "}{page * 10 + 10}{" "}
                                                                </span>
                                                            )}{" "}
                                                            of <span class="font-medium">{parcelcount2}</span> results
                                                        </p>
                                                    </div>

                                                    <nav aria-label="Page navigation">
                                                        <ul className="pagination">
                                                            {current > 10 ? (<>

                                                                <li>
                                                                    <a onClick={() => nextpage(page - 1)} aria-label="Previous">
                                                                        <span aria-hidden="true">«</span>
                                                                    </a>
                                                                </li>

                                                                <li>
                                                                    <a onClick={() => nextpage(page - 1)}>{page}</a>
                                                                </li>
                                                            </>
                                                            )
                                                                : null}

                                                            <li>
                                                                <a className="active" onClick={() => nextpage(page)} >{page + 1}</a>
                                                            </li>
                                                            {current < parcelcount2 ? (
                                                                <>
                                                                    <li>
                                                                        <a onClick={() => nextpage(page + 1)}>{page + 2}</a>
                                                                    </li>
                                                                    <li>
                                                                        <a onClick={() => nextpage(page + 1)} aria-label="Next">
                                                                            <span aria-hidden="true">»</span>
                                                                        </a>
                                                                    </li>
                                                                </>
                                                            ) : null}
                                                        </ul>
                                                    </nav>
                                                </div>
                                            </>

                                        ) : (
                                            <table className="table-custom">
                                                <thead className="table-header-row">
                                                    <tr>
                                                        <th>DATE</th>
                                                        <th>ORDER ID</th>
                                                        <th>AMOUNT</th>
                                                        <th>STATUS</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="table-body">
                                                    {
                                                        [...Array(counttransactions)].map((e, i) => <>
                                                            {transactions && transactions[i] != '' ? (
                                                                <tr key={i} className={`table-row ${i % 2 === 1 ? 'odd' : 'even'}`}>
                                                                    <td className="table-cell">{transactions[i].date_on}</td>
                                                                    <td className="table-cell">{transactions[i].id}</td>
                                                                    <td className="table-cell">{transactions[i].amount} PAID</td>
                                                                    <td className="table-cell">SUCCESS</td>
                                                                </tr>
                                                            ) : null}
                                                        </>
                                                        )}

                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
